import React from "react";
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import TagManager from 'react-gtm-module';

function Caption0303() {
	const tagManagerArgs = {
		gtmId: 'GTM-NDBLPCX'
	}
	TagManager.initialize(tagManagerArgs);
	return (
	<>
	<div className="content_inpage">
		<div className="pagesize">	
			<ul className="bread">
				<li><a href="/">首頁</a></li>
				<li><a href="/container/caption">服務說明</a></li>
				<li><a href="/container/caption/Caption0301">音樂故事清單</a></li>
				<li><a href="/container/caption/Caption0303">放心播</a></li>
			</ul>
			<h2 className="tit_main">放心播</h2>
				<div className="content_box music_box mb_relax">
					<div className="cb_set">
						<p className="total_info"><span>46</span>首，共<span>1</span>頁</p>
						<div className="mb_detail flex_set">
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>內地華語精選</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>華夏HIGH舞曲</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>華夏流行金曲</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>和風輕音樂</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>嘻哈饒舌瘋</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>重金屬搖滾</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>輕搖滾</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>電音精選</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>摩登電音</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>爵士精選</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>爵士輕鬆聽</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>爵士演唱輯</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>爵士演奏輯</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>巴薩諾瓦</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>變調薩克斯風</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>古典名曲</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>巴洛克時期</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>古典樂派</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>浪漫樂派</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>紓壓輕鬆聽</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>樂活時光</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>浪漫晚餐</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>夜深人靜</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>下班後小酒館</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>High翻天</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>動感熱力</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>瑜珈冥想</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>清淨身心靈</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>輕柔絮語</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>開放大自然</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>運動健身</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>陽光沙灘海浪</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>動人情調</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>情人耳邊呢喃</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>浪漫婚禮演奏篇</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>鋼琴饗宴</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>廣告配樂精選</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>新世紀</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>美聲天籟</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>福音歌曲</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>佛教音樂</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>晚安打烊曲</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>生日快樂</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>頒獎樂</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>農曆新年慶團圓</h4>
								</div>
							</div>
							<div className="mb_box flex_box">
								<div className="mb_txt">
									<h4>歡度耶誕夜</h4>
								</div>
							</div>
						</div>
						{/* <ul className="page_control">
							<li><a href="javascript:void();" className="btn_prev_01"></a></li>
							<li><a href="javascript:void();" className="btn_prev_02"></a></li>
							<li className="active"><a href="javascript:void();">1</a></li>
							<li><a href="music_01_05_page02.html">2</a></li>
							<li><a href="music_01_05_page02.html" className="btn_next_01"></a></li>
							<li><a href="music_01_05_page02.html" className="btn_next_02"></a></li>
						</ul> */}
					</div>
				</div>
		</div>
	</div>
	</>
	)
}

export default Caption0303;